import { useState, useCallback, lazy, Suspense } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  attachToParty as attachToPartyAction,
  setSelectedPartyData,
  addToCart,
  addChecks,
  updateSeatInfo,
  replaceCart,
} from '@reducers/orders';
import { CUSTOM_MESSAGES } from '@veriables';
import { safeJsonParse } from '@utility/helperFunction';

const AttachToParty = lazy(() =>
  import('@components/common/TableComponentRow/AttachToParty')
);

const useAttachToParty = ({
  checkData,
  deviceInfo,
  userInfo,
  serverAppTheme,
  setErrorPopUp,
  onClose,
}) => {
  const dispatch = useDispatch();
  const selectedPartyData = useSelector(s => s.orders.selectedPartyData);
  const loading = useSelector(s => s.orders?.loading);
  const menusList = useSelector(s => s.orders?.menusList);
  const menuIndex = useSelector(s => s.orders?.menuIndex);

  const [partyData, setPartyData] = useState([]);
  const [isPartyModal, setIsPartyModal] = useState(false);
  const [isOpenConfirmationParty, setOpenConfirmationParty] = useState(false);

  const open = useCallback(() => {
    const data = {
      storeId: deviceInfo?.storeId,
      deviceId: deviceInfo?.deviceId,
      employeeId: Number(userInfo?.id),
      checkHeaderId: checkData?.id,
    };
    dispatch(attachToPartyAction(data))
      .then(resData => {
        setPartyData(resData.events.map(item => ({ ...item, isCheck: false })));
        setIsPartyModal(true);
      })
      .catch(err => setErrorPopUp({ res: err.message }));
  }, [dispatch, deviceInfo, userInfo, checkData, setErrorPopUp]);

  const handleFinalClickAttchParty = useCallback(() => {
    if (selectedPartyData) {
      setOpenConfirmationParty(true);
    } else {
      setErrorPopUp({
        res: CUSTOM_MESSAGES().ATP_PLEASE_SELECT_PARTY,
        noErrorTxt: true,
      });
    }
  }, [selectedPartyData, setErrorPopUp]);

  const handleSetSelectedPartyData = useCallback(
    d => dispatch(setSelectedPartyData(d)),
    [dispatch]
  );

  const handleAddPartyToCart = useCallback(() => {
    const menuTypeId = Number(window.sessionStorage.getItem('menuTypeId'));
    const seatIds = checkData?.seats?.filter(s => s.open).map(s => s.id) ?? [];

    const dataToSend = {
      quantity: 1,
      price: 0,
      menuItemId: selectedPartyData?.menuItemId,
      modifiers: [],
      note: selectedPartyData?.eventNumber,
      menuItemName: selectedPartyData?.menuItemName,
      serverAppModifierGroupDisplayStyle: 0,
      modifierObject: [],
      menuTypeId,
      brandCourseId: null,
      openPrice: false,
    };

    const requestData = {
      ...dataToSend,
      pending: true,
      seatIds,
      price: 0,
      menuScreenId: menuTypeId,
      internalId: new Date().getTime(),
      menuId: menusList[menuIndex]?.id,
      modifiers: dataToSend.modifierObject,
      modifierData: dataToSend.modifiers,
    };

    requestData.modifierJson = JSON.stringify({ ...requestData, attachToParty: true });
    const cartData = { ...requestData, isProcessing: true };

    dispatch(addToCart(cartData)).then(() => {
      const apiData = {
        storeId: deviceInfo?.storeId,
        deviceId: deviceInfo?.deviceId,
        employeeId: Number(userInfo?.id),
        employeeCard: userInfo?.employeeCard,
        checkHeaderId: checkData?.id,
        stationId: checkData?.stationId,
        items: [cartData],
        orderJson: JSON.stringify([cartData]),
        longitude: '0',
        latitude: '0',
        geoLocation: '0',
      };
      dispatch(addChecks(apiData, 'add'))
        .then(res => {
          dispatch(updateSeatInfo(res));
          const ItemsArray = res.orders?.[0]?.items ?? [];
          const CartItems = ItemsArray.filter(
            i => i.pending && i.itemType !== 'D'
          ).map(item => ({
            ...safeJsonParse(safeJsonParse(item.orderJson, {})?.modifierJson, {}),
            isProcessing: false,
            modifierJson: safeJsonParse(item.orderJson, {})?.modifierJson,
            id: item.id,
            checkItemId: item.checkItemId,
          }));
          dispatch(replaceCart(CartItems));
        })
        .catch(err => setErrorPopUp({ res: err.message }));
    });

    setOpenConfirmationParty(false);
    setIsPartyModal(false);
    dispatch(setSelectedPartyData(null));
    onClose();
  }, [
    selectedPartyData,
    checkData,
    deviceInfo,
    userInfo,
    menusList,
    menuIndex,
    dispatch,
    onClose,
    setErrorPopUp,
  ]);

  const jsx = (
    <Suspense fallback={null}>
      {(isPartyModal || isOpenConfirmationParty) && (
        <AttachToParty
          isPartyModal={isPartyModal}
          setIsPartyModal={setIsPartyModal}
          isOpenConfirmationParty={isOpenConfirmationParty}
          setOpenConfimrationParty={setOpenConfirmationParty}
          partyData={partyData}
          serverAppTheme={serverAppTheme}
          seat={checkData}
          loading={loading}
          selectedPartyData={selectedPartyData}
          setSelectedPartyData={handleSetSelectedPartyData}
          handleFinalClickAttchParty={handleFinalClickAttchParty}
          handleAddPartyToCart={handleAddPartyToCart}
          displaySideMenu={false}
        />
      )}
    </Suspense>
  );

  return { open, jsx };
};

export default useAttachToParty;
